import React, { forwardRef } from "react";
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
} from "react-router-dom";
import { Link, LinkProps } from "@chakra-ui/react";

type RouterLinkProps = ReactRouterLinkProps & LinkProps;

const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(
  ({ children, ...props }, ref) => {
    return (
      <Link as={ReactRouterLink} ref={ref} {...props}>
        {children}
      </Link>
    );
  }
);

RouterLink.defaultProps = {
  _hover: {
    textDecoration: "none",
  },
};

export default RouterLink;
